module.exports = __webpack_public_path__ + "img/5.13a87633.jpg";